import { render, staticRenderFns } from "./receiverRecord.vue?vue&type=template&id=1d768842&scoped=true&"
import script from "./receiverRecord.vue?vue&type=script&lang=js&"
export * from "./receiverRecord.vue?vue&type=script&lang=js&"
import style0 from "./receiverRecord.vue?vue&type=style&index=0&id=1d768842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d768842",
  null
  
)

export default component.exports